//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import $ from 'jquery';
import axios from 'axios';

export default {
  layout: function layout(context) {
    return global.getTheme();
  },
  data: function data() {
    return {
      errorMessage: '',
      placeHolderMessage: '',
      results: [],
      loading: false,
      view: 'default'
    };
  },
  mounted: function mounted() {},

  computed: {
    lang: function lang() {
      return this.$root._route.params.lang;
    }
  },
  created: function created() {
    var _this = this;

    this.view = global.getTheme();
    if (process.client) {
      this.isAuth = this.$auth.isAuthenticated();
      this.refreshLoggedUser();
      if (!this.isAuth) {
        this.$router.push({ name: 'lang-login', params: { lang: this.lang } });
      }
      axios.get(global.getEndPoint() + 'api/search-history').then(function (resp) {
        var processedData = resp.data;
        for (var i in processedData) {
          /*if(processedData[i].raw_name)
              processedData[i].search_type="name";
          else if(processedData[i].email)
              processedData[i].search_type="email";
          else if(processedData[i].phone)
              processedData[i].search_type="phone";*/
          //processedData[i].query = processedData[i].raw_name?processedData[i].raw_name:(processedData[i].email?processedData[i].email:processedData[i].phone);

        }
        _this.results = processedData;
      });
    }
  },

  methods: {
    refreshLoggedUser: function refreshLoggedUser() {
      this.$auth.getUser(function (user) {
        this.loggedUser = user;
      }.bind(this));
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/member/search-history.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/member/search-history.vue
// module chunks = 37